import React, { useState, useEffect } from 'react';

import Axios from "axios";  
import {Link, useNavigate} from "react-router-dom";

import {MDBBtn, MDBTable, MDBTableHead, MDBTableBody, MDBIcon, MDBBadge} from "mdb-react-ui-kit";

import CalendarEntries from '../components/Calendar';

import Moment from 'moment';
import { backendPathCustomers, backendPathTasks, GREEN_THRESHOLD, YELLOW_THRESHOLD } from '../Constants';
import {checkVisibility} from "../functions/visibility";
import DatePicker from "react-datepicker";
import {getAbsoluteMonths, isWeekday} from "../functions/date";
import {loadPermissions} from "../functions/permissions";
import TopNavbar from "../components/Navbar";


Date.prototype.monthDays = function() {
    const d = new Date(this.getFullYear(), this.getMonth()+1, 0);
    return d.getDate();
}

Moment.prototype.diff = function(endDay) {
    let diff = 0;
    let d = this;
    while (d.isSameOrBefore(endDay)) {
        d = d.add(1, 'days');
        diff = diff + 1;
    }
    return diff;
};


function Home() {
    const navigate = useNavigate();

    const [date, setDate] = useState(new Date());
    const [month, setMonth] = useState([]);
    const [taskList, setTaskList] = useState([]);
    const [taskForColorsList, setTaskForColorsList] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [customerListColored, setCustomerListColored] = useState([]);
    const [offset, setOffset] = useState(0);

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);

    const getCustomers = () => {
        Axios.get(backendPathCustomers+"customers-overview.php").then((response) => {
            setCustomerList(response.data);
            console.log(response.data);
        });
    };

    const getTasksForColors = (c) => {
        Axios.get(backendPathTasks+"tasks-for-colors.php").then((response) => {
            setTaskForColorsList(response.data);
            console.log(response.data);
        });
    }

    const getTasks = () => {
        const firstDay = Moment(new Date(date.getFullYear(), date.getMonth(), 1)).format("YYYY-MM-DD");
        const lastDay = Moment(new Date(date.getFullYear(), date.getMonth() + 1, 0)).format("YYYY-MM-DD");

        Axios.get(`${backendPathTasks}tasks-with-employee-for-month.php?firstDay=${firstDay}&lastDay=${lastDay}`).then((response) => {
            setTaskList(response.data);
            console.log(`loaded data tasks for month ${firstDay} to ${lastDay}`)
            console.log(response.data);
        });
    };

    const getColorFromDuration = (duration) => {
        if (duration < YELLOW_THRESHOLD) {
            return "red";
        }
        if (duration < GREEN_THRESHOLD) {
            return "yellow";
        }
        return "green";
    }

    // traffic light calc function
    const getColorOfCustomer = (cId) => {
        let tasks = taskForColorsList;

        if (tasks.length === 0) {
            return "red";
        }

        // remove tasks of other customers
        tasks = tasks.filter((t) => t.CustomerID === cId);
        // only include tasks with end after today or start before today+35days
        tasks = tasks.filter((t) => Moment(t.EndDate).isSameOrAfter(Moment().format("YYYY-MM-DD")) && Moment(t.StartDate).isSameOrBefore(Moment().add(35, 'days')));
        tasks.sort(function(a, b) { return new Date(a.StartDate) - new Date(b.StartDate) });

        if (!tasks.length) {
            return "red";
        }

        // return red if startday is not today (-> hole at begin)
        if (!Moment(tasks[0].StartDate).isSame(Moment(), 'days')) {
            return "red";
        }

        if (tasks.length === 1) {
            const plannedDuration = Moment(Moment(tasks[0].StartDate)).diff(Moment(tasks[0].EndDate));
            return getColorFromDuration(plannedDuration);
        }

        let endD = Moment(new Date()).subtract(1, 'days').format("YYYY-MM-DD");

        for (let i = 0; i < tasks.length; i++) {
            if (Moment(Moment(tasks[i].StartDate).format("YYYY-MM-DD")).isAfter(Moment(endD).add(1, 'days'))) {
                // found "hole" in planning -> stop adding to duration
                const plannedDuration = Moment(new Date()).diff(Moment(tasks[i-1].EndDate));
                return getColorFromDuration(plannedDuration);
            }
            endD = Moment(tasks[i].EndDate);
        }
        const plannedDuration = Moment(Moment().format("YYYY-MM-DD")).diff(Moment(endD));
        return getColorFromDuration(plannedDuration);
    }

    const getCustomerColors = () => {
        const customers = customerList;
        for (let i=0; i < customerList.length; i++) {
            customers[i]["Color"] = getColorOfCustomer(customerList[i].CustomerID);
        }
        setCustomerListColored(customers);
    }

    const fillMonth = () => {
        const m = [];
        let d = Moment(new Date(date.getFullYear(), date.getMonth(), 1));
        for (let i = 0; i < date.monthDays(); i++) {
            const isWeekend = !isWeekday(new Date(d));
            m.push({label: `${i+1}.`, class: isWeekend ? "weekend" : ""});
            d = Moment(d).add(1, 'days').format("YYYY-MM-DD");
        }
        setMonth(m);
    };

    const addMonth = () => {
        setMonth([]);
        setDate(new Date(date.getFullYear(), date.getMonth() + 1, 1));
        fillMonth();
        setOffset(offset+1);
    };

    const changeDate = (newDate) => {
        setMonth([]);
        setDate(new Date(newDate.getFullYear(), newDate.getMonth(), 1));
        fillMonth();
        setOffset(getAbsoluteMonths(newDate) - getAbsoluteMonths(new Date()));
    };

    const subMonth = () => {
        setMonth([]);
        setDate(new Date(date.getFullYear(), date.getMonth() - 1, 1));
        fillMonth();
        setOffset(offset-1);
    };

    function tariffChar(tariffNumber) {
        if (tariffNumber === null) {
            return " ";
        }
        if (Number(tariffNumber) === 0 || Number(tariffNumber) === 1) {
            return "B";
        }
        else if (Number(tariffNumber) === 2) {
            return "S"
        }
        else if (Number(tariffNumber) === 3) {
            return "G"
        }
    }

    useEffect(() => {
        loadPermissions(navigate, setReadPermission, setWritePermission);
    }, []);

    useEffect(() => {
        fillMonth();
        console.log(Moment(date).format("DD.MM.YYYY"))
    }, [date]);

    useEffect(() => {
        getCustomers();
    }, [month]);

    useEffect(() => {
        if (customerList) {
            getTasksForColors();
        }
    }, [customerList]);

    useEffect(() => {
        getCustomerColors();
    }, [taskForColorsList])

    useEffect(() => {
        getTasks();
    }, [customerListColored])


    return (

        <>
            <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>
            <div className='main'>
                <div className="header-above-table">
                    <h2>Einsatzübersicht</h2>

                    <button className='arrowBtnLeft' onClick={subMonth}><MDBIcon icon='angle-left' size='3x'/></button>
                    <h2>
                        <DatePicker
                            portalId="date-popper"
                            className="month-picker"
                            locale="de"
                            selected={date}
                            onChange={(d) => changeDate(d)}
                            showMonthYearPicker
                            dateFormat="MMMM yyyy"
                        />
                    </h2>
                    <button className='arrowBtnRight' onClick={addMonth}><MDBIcon icon='angle-right' size='3x'/>
                    </button>

                    <Link className="link calendar-h" to="/new-task">
                        <MDBBtn className="btn">Einsatz planen</MDBBtn>
                    </Link>
                </div>


                <MDBTable className='month-table table-bordered' align='middle'>
                    <MDBTableHead className="table-head">
                        <tr>
                            <th scope='col'>Kunde</th>
                            {month.map((item, key) => <th scope='col' key={key} className={item.class}>{item.label}</th>)}
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                        <tr className="table-body-calendar"><td></td></tr>
                        {customerListColored
                            .filter(value => checkVisibility(value["PartnerID"], "partner"))
                            .filter(value => checkVisibility(value["OfficeEmployeeID"], "officeEmployee"))
                            .map((customer, cKey) => {
                            return (
                                <tr key={cKey}>
                                    <td>
                                        <div className="d-flex align-items-center" style={{display: "flex"}}>
                                            <h6><MDBBadge className='mx-1'
                                                          color={customer.Tariff ?
                                                              (customer.Tariff === "0" ? "primary" :
                                                                  (customer.Tariff === "1" ? "dark" :
                                                                      (customer.Tariff === "2" ? "light" : "info")))
                                                              : "transparent"}
                                                          light>
                                                {tariffChar(customer.Tariff)}
                                            </MDBBadge></h6>
                                            <p className='name-cell'>{customer.FirstName[0]+"."}&nbsp;{customer.LastName}</p>
                                            <MDBBadge className='rounded-circle p-2 traffic-light'
                                                      color={customer.Color === "red" ? "danger" :
                                                          (customer.Color === "yellow" ? "warning" : "success")}
                                                      light> </MDBBadge>
                                        </div>
                                    </td>
                                    <CalendarEntries offset={offset} tasks={taskList.filter(t => Number(t["CustomerID"]) === Number(customer["CustomerID"]))}></CalendarEntries>
                                </tr>
                            );
                        })}
                    </MDBTableBody>
                </MDBTable>


            </div>
        </>
    );
}

export default Home;